import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../initial-state';
import {
  auditLogList,
  setAuditLogType,
  clearAllFilters,
  applyFilters
} from '../../actions/audit-log';
import * as UIActions from '../../actions/ui';
import { jumpContext } from '../../actions/contexts.action';
import {
  dateCriteria,
  logTypeCriteria,
  dictionaryActionCriteria,
  organizationActionCriteria
} from './audit-log-field-definitions';

const reducer = createReducer(InitialState.auditLog, (builder) => {
  builder.addCase(UIActions.logout.type, () => ({ ...InitialState.auditLog }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.auditLog }));

  builder.addCase(auditLogList, (state, action) => {
    const auditLogs = action.payload;
    const { sortablePageable, criteriaFilter } = state;
    const auditLogs_content = auditLogs.content;

    const sp = {
      ...sortablePageable,
      items: auditLogs_content,
      pageableDefinition: {
        ...auditLogs,
        content: auditLogs_content
      }
    };

    const cFilter = {
      ...criteriaFilter,
      filters: sp.filterableOptions.filters ?? criteriaFilter.filters
    };

    return {
      ...state,
      sortablePageable: sp,
      auditLogs: auditLogs_content,
      criteriaFilter: cFilter
    };
  });

  builder.addCase(setAuditLogType, (state, action) => {
    const logType = action.payload;
    let filterFormList = [dateCriteria, logTypeCriteria];
    switch (logType) {
      case 'Organization':
        filterFormList = [...filterFormList, organizationActionCriteria];
        break;
      case 'Dictionary':
        filterFormList = [...filterFormList, dictionaryActionCriteria];
        break;
      case 'All':
        filterFormList = [dateCriteria, logTypeCriteria];
        break;
      default:
        break;
    }

    return {
      ...state,
      criteriaFilter: {
        ...state.criteriaFilter,
        filterForms: filterFormList
      }
    };
  });

  builder.addCase(clearAllFilters, state => ({
    ...state,
    filterLoadStates: InitialState.cases.filterLoadStates,
    criteriaFilter: {
      ...state.criteriaFilter,
      filters: [],
      dateFilter: undefined
    },
    sortablePageable: {
      ...state.sortablePageable,
      filterableOptions: {
        ...state.sortablePageable.filterableOptions,
        dateFilter: undefined,
        filters: []
      },
      dateFilter: undefined
    }
  }));

  builder.addCase(applyFilters, (state, action) => {
    const filterableOptions = action.payload;
    const { criteriaFilter } = state;
    return {
      ...state,
      criteriaFilter: {
        ...state.criteriaFilter,
        filters: filterableOptions?.filters ?? criteriaFilter?.filters,
        dateFilter: filterableOptions?.dateFilter ?? criteriaFilter?.dateFilter
      },
      sortablePageable: {
        ...state.sortablePageable,
        filterableOptions: {
          ...state.sortablePageable.filterableOptions,
          filters: filterableOptions?.filters ?? criteriaFilter.filters,
          dateFilter: filterableOptions?.dateFilter
        }
      }
    };
  });
});

export default reducer;
